import { render, staticRenderFns } from "./ValidationData.vue?vue&type=template&id=14597870&scoped=true"
import script from "./ValidationData.vue?vue&type=script&lang=js"
export * from "./ValidationData.vue?vue&type=script&lang=js"
import style0 from "./ValidationData.vue?vue&type=style&index=0&id=14597870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14597870",
  null
  
)

export default component.exports